import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_BOARDING_LINES](state, data) {
    state.allBoardingLines = data
  },
}
